import './DashboardMiniCard.css';

import React, { useEffect } from 'react';
import FieldComponent from '../../b2b-common/FieldComponent';
import { generateClassName } from '../../b2b-common/helpers';
import AccessLevel from '../../b2b-plans/components/AccessLevel';
import Counter from '../../b2b-common/Counter';
import { AreaIndicatorWidgetModalContext } from '../forms/AreaIndicatorWidgetModal';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

export const DashboardGridConfiguration = ({ dashboard }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    return (
        <FieldComponent label={t("Grid Configuration")} labelAlign='center' className={'dashboard-grid-configuration'}
            component={<span>{dashboard.dashboardConfig.rows} x {dashboard.dashboardConfig.columns}</span>}
        />
    );
};

const DashboardMiniCard = ({ dashboard, selectedDashboard = null, className = null, onSelect }) => {

    const [currentDashboard, setCurrentDashboard] = React.useState(dashboard);
    // const { selectedDashboard } = React.useContext(AreaIndicatorWidgetModalContext);
    const { t } = useB2BTranslation('b2b-reporting');

    useEffect(() => {
        if (dashboard.dashboardId !== currentDashboard.dashboardId)
            setCurrentDashboard(dashboard);
    }, [dashboard]);

    const handleClickOnCard = () => {
        onSelect && onSelect(currentDashboard);
    }

    return (
        <div className={`${generateClassName('dashboard-mini-card', '', className)} ${(selectedDashboard && (selectedDashboard.dashboardId == currentDashboard.dashboardId)) ? 'selected' : ''}`} onClick={handleClickOnCard}>
            <FieldComponent label={t("Dashboard Name")} labelAlign='left'
                component={<h4>{currentDashboard.dashboardName}</h4>}
                className={'dashboard-mini-card-field'}
            />
            <AccessLevel
                readOnly={currentDashboard.readOnly}
                className={'dashboard-card-access-level'} />
            <DashboardGridConfiguration
                dashboard={currentDashboard} />
            <Counter label='Widgets' count={currentDashboard.widgets.length} minDigits={2} className={'dashboard-card-widgets-counter'} />
        </div>
    );
};

export default DashboardMiniCard;